var SOE_CONSULTATION_KEY = 'soe.consultation.v2';
function readSoeConsultation() {
  try {
    const state = JSON.parse(sessionStorage.getItem(SOE_CONSULTATION_KEY));
    if (!state || state.version !== 2 || !Number.isFinite(state.savedAt) || Date.now() - state.savedAt > 7200000 || state.savedAt > Date.now()) return null;
    const a = state.answers;
    if (!a || !['milk','espresso','both'].includes(a.drinks) || !['guided','learn','craft'].includes(a.control) || !['starter','mid','high'].includes(a.budget) || !['integrated','separate','owned'].includes(a.grinder)) return null;
    if (a.budget === 'high' && (!Number.isFinite(a.customBudget) || a.customBudget <= 0)) return null;
    if (!Number.isFinite(state.maxBudget) || state.maxBudget <= 0 || !Array.isArray(state.labels) || state.labels.length !== 4) return null;
    if (!state.labels.every((s) => typeof s === 'string' && s.length < 160)) return null;
    return state;
  } catch (_) { return null; }
}

function readSoeConsultationVisit(productId) {
  const saved = readSoeConsultation();
  const source = new URL(window.location.href).searchParams.get('soe_setup');
  return saved && source === String(saved.savedAt) && String(saved.machineId) === String(productId) ? saved : null;
}

function selectSoeSetups(profiles, answers) {
  const cap = answers.maxBudget;
  if (!Number.isFinite(cap) || cap <= 0) return { selected: [], notice: null, invalidBudget: true };
  const price = (p) => answers.grinder === 'separate' ? p.setupPrice : p.machinePrice;
  const drinkFit = (p) => answers.drinks === 'both'
    ? Number(p.espressoPriority) + Number(p.milkPriority)
    : Number(answers.drinks === 'milk' ? p.milkPriority : p.espressoPriority);
  const fit = (p) => Number(p.fit[answers.control]) || 0;
  const compare = (a, b) => fit(b) - fit(a) || drinkFit(b) - drinkFit(a)
    || price(a) - price(b) || String(a.id).localeCompare(String(b.id));
  const betterFit = (a, b) => !b || fit(a) > fit(b) || (fit(a) === fit(b) && drinkFit(a) > drinkFit(b));
  const identity = (p) => !!p.id && p.machineAvailable && !!p.variantId;
  const complete = (p) => identity(p) && (answers.grinder !== 'separate' || p.grinderAvailable);
  const seen = new Set();
  const preferred = profiles.filter((p) => p.id && p.flags[answers.control]
    && (p.drinks === 'both' || p.drinks === answers.drinks)
    && (answers.grinder === 'integrated' ? p.grinderMode === 'integrated' : p.grinderMode === 'separate'))
    .sort(compare).filter((p) => { if (seen.has(p.id)) return false; seen.add(p.id); return true; });
  const eligible = preferred.filter((p) => complete(p) && Number.isFinite(price(p)) && price(p) > 0 && price(p) <= cap);
  const best = eligible[0];
  const alternative = best && eligible.filter((p) => p.id !== best.id && p.group !== best.group)
    .sort((a, b) => drinkFit(b) - drinkFit(a) || compare(a, b))[0];
  const ideal = preferred[0];
  let notice = null;
  if (ideal && ideal.id !== best?.id && betterFit(ideal, best)) {
    if (!identity(ideal)) notice = { kind: 'machine_unavailable', profile: ideal };
    else if (answers.grinder === 'separate' && !ideal.grinderAvailable) notice = { kind: 'grinder_unavailable', profile: ideal };
    else if (price(ideal) > cap) notice = { kind: 'over_budget', profile: ideal, price: price(ideal), cap };
  }
  return { selected: best ? [best, alternative].filter(Boolean) : [], notice, invalidBudget: false };
}

if (!customElements.get('soe-setup-matcher')) {
  customElements.define('soe-setup-matcher', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.questions = Array.from(this.querySelectorAll('[data-question]'));
      this.quiz = this.querySelector('[data-matcher-quiz]');
      this.results = this.querySelector('[data-matcher-results]');
      this.cards = Array.from(this.querySelectorAll('[data-matcher-candidate]'));
      this.profiles = Array.from(this.querySelectorAll('[data-matcher-candidate], [data-matcher-blocked]'));
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP', maximumFractionDigits: 2 });
      this.answers = {};
      this.index = 0;
      this.quiz.hidden = false;
      this.results.hidden = true;
      this.querySelector('[data-matcher-restart]').hidden = false;
      const prepareConsultationLink = (event) => {
        const link = event.target.closest('[data-matcher-view]');
        if (!link || !this.contains(link)) return;
        const state = this.saveConsultation(link.closest('[data-matcher-candidate]'));
        const url = new URL(link.href, window.location.href);
        if (state) url.searchParams.set('soe_setup', String(state.savedAt));
        else url.searchParams.delete('soe_setup');
        link.href = url.href;
      };
      this.addEventListener('auxclick', (event) => { if (event.button === 1) prepareConsultationLink(event); }, { signal: this.controller.signal });
      this.addEventListener('contextmenu', prepareConsultationLink, { signal: this.controller.signal });
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-matcher-view]');
        if (link && this.contains(link)) { prepareConsultationLink(event); return; }
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-answer')) {
          const key = this.questions[this.index].dataset.question;
          this.answers[key] = button.dataset.answer;
          if (key === 'budget' && button.dataset.answer === 'high') {
            this.showQuestion(false);
            this.querySelector('[data-matcher-budget-input]').focus();
            return;
          }
          this.advance();
        } else if (button.hasAttribute('data-matcher-budget-continue')) {
          const input = this.querySelector('[data-matcher-budget-input]');
          if (!input.reportValidity()) return;
          const amount = Math.round(Number(input.value) * 100);
          if (!Number.isFinite(amount) || amount <= 0) return;
          this.answers.customBudget = amount;
          this.advance();
        } else if (button.hasAttribute('data-matcher-edit')) {
          this.index = Number(button.dataset.matcherEdit);
          this.editing = true;
          this.results.hidden = true;
          this.quiz.hidden = false;
          this.showQuestion(true);
        } else if (button.hasAttribute('data-matcher-back')) {
          this.index = Math.max(0, this.index - 1);
          this.showQuestion(true);
        } else if (button.hasAttribute('data-matcher-restart')) {
          this.answers = {};
          this.editing = false;
          try { sessionStorage.removeItem(SOE_CONSULTATION_KEY); } catch (_) {}
          this.index = 0;
          this.results.hidden = true;
          this.quiz.hidden = false;
          this.showQuestion(true);
        }
      }, { signal: this.controller.signal });
      const saved = readSoeConsultation();
      if (saved) {
        this.answers = saved.answers;
        if (this.answers.budget === 'high') this.querySelector('[data-matcher-budget-input]').value = this.answers.customBudget / 100;
        this.showResult();
      } else this.showQuestion(false);
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
    saveConsultation(card) {
      if (!card) return null;
      const caps = { starter: Number(this.dataset.starterCap), mid: Number(this.dataset.midCap), high: this.answers.customBudget };
      const state = { version: 2, savedAt: Date.now(), answers: { ...this.answers }, maxBudget: caps[this.answers.budget],
        labels: Array.from(this.querySelectorAll('[data-matcher-choice]')).map((e) => e.textContent),
        machineId: card.dataset.productId, variantId: card.dataset.variantId,
        grinderId: card.dataset.grinderId, grinderVariantId: card.dataset.grinderVariantId, grinderHandle: card.dataset.grinderHandle };
      try { sessionStorage.setItem(SOE_CONSULTATION_KEY, JSON.stringify(state)); return state; } catch (_) { return null; }
    }
    advance() {
      if (this.editing || this.index === this.questions.length - 1) this.showResult();
      else { this.index += 1; this.showQuestion(true); }
    }
    showQuestion(focus) {
      this.questions.forEach((question, position) => {
        question.hidden = position !== this.index;
        question.querySelectorAll('[data-answer]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.answer === this.answers[question.dataset.question])));
      });
      this.querySelector('[data-matcher-custom-budget]').hidden = this.questions[this.index].dataset.question !== 'budget' || this.answers.budget !== 'high';
      this.querySelector('[data-matcher-progress]').style.width = ((this.index + 1) / this.questions.length * 100) + '%';
      this.querySelector('[data-matcher-step]').textContent = this.dataset.questionLabel.replace('[current]', this.index + 1).replace('[total]', this.questions.length);
      this.querySelector('[data-matcher-back]').hidden = this.index === 0;
      if (focus) {
        const legend = this.questions[this.index].querySelector('legend');
        legend.focus({ preventScroll: true });
        legend.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }
    showResult() {
      this.editing = false;
      this.querySelectorAll('[data-matcher-edit]').forEach((button, index) => {
        const question = this.questions[index];
        const answer = Array.from(question.querySelectorAll('[data-answer]')).find((option) => option.dataset.answer === this.answers[question.dataset.question]);
        button.querySelector('[data-matcher-choice]').textContent = question.dataset.question === 'budget' && this.answers.budget === 'high'
          ? this.dataset.upTo + ' ' + this.money.format(this.answers.customBudget / 100) : answer.querySelector('strong').textContent;
      });
      this.querySelector('[data-matcher-choices]').hidden = false;
      const caps = { starter: Number(this.dataset.starterCap), mid: Number(this.dataset.midCap), high: this.answers.customBudget };
      const mode = this.answers.grinder;
      const profiles = this.profiles.map((node) => {
        const d = node.dataset;
        return { node, id: d.productId, variantId: d.variantId, title: d.title || node.querySelector('h3')?.textContent,
          machinePrice: Number(d.machinePrice), setupPrice: Number(d.setupPrice), grinderMode: d.grinderMode,
          machineAvailable: d.machineAvailable === 'true', grinderAvailable: d.separateAvailable === 'true',
          flags: { guided: d.guided === 'true', learn: d.learn === 'true', craft: d.craft === 'true' },
          fit: { guided: Number(d.guidedFit), learn: Number(d.learnFit), craft: Number(d.craftFit) },
          drinks: d.drinks, espressoPriority: d.espressoPriority === 'true', milkPriority: d.milkPriority === 'true', group: d.workflowGroup };
      });
      const decision = selectSoeSetups(profiles, { ...this.answers, maxBudget: caps[this.answers.budget] });
      const eligible = decision.selected.map((p) => p.node);
      const notice = this.querySelector('[data-matcher-notice]');
      notice.hidden = !decision.notice;
      if (decision.notice) {
        const n = decision.notice;
        const template = n.kind === 'over_budget' ? this.dataset.overBudget : n.kind === 'grinder_unavailable' ? this.dataset.grinderUnavailable : this.dataset.machineUnavailable;
        notice.textContent = template.replace('[product]', n.profile.title).replace('[price]', this.money.format(n.price / 100)).replace('[budget]', this.money.format(n.cap / 100));
      }
      this.cards.forEach((card) => {
        const position = eligible.indexOf(card);
        card.hidden = position === -1;
        const total = card.querySelector('[data-matcher-setup-price]');
        const machine = card.querySelector('[data-matcher-machine-price]');
        const grinder = card.querySelector('[data-matcher-grinder]');
        const owned = card.querySelector('[data-matcher-owned]');
        if (total) total.hidden = mode !== 'separate';
        if (machine) machine.hidden = mode === 'separate';
        if (grinder) grinder.hidden = mode !== 'separate';
        if (owned) owned.hidden = mode !== 'owned';
        const difference = card.querySelector('[data-matcher-difference]');
        difference.hidden = position !== 1;
        if (position === 1) {
          const priceKey = mode === 'separate' ? 'setupPrice' : 'machinePrice';
          const delta = decision.selected[1][priceKey] - decision.selected[0][priceKey];
          difference.textContent = delta === 0 ? this.dataset.same : this.money.format(Math.abs(delta) / 100) + ' ' + (delta > 0 ? this.dataset.more : this.dataset.less);
        }
        if (position !== -1) card.querySelector('[data-matcher-card-label]').textContent = position === 0 ? (decision.notice ? this.dataset.fallbackLabel : this.dataset.firstLabel) : this.dataset.alternativeLabel;
      });
      // Move the selected cards in rank order so visual and reading order match.
      eligible.forEach((card) => card.parentElement.appendChild(card));
      this.querySelector('[data-matcher-empty]').hidden = eligible.length > 0;
      const heading = this.querySelector('[data-matcher-heading]');
      heading.textContent = eligible.length ? this.dataset.matchHeading : this.dataset.emptyHeading;
      this.quiz.hidden = true;
      this.results.hidden = false;
      heading.focus({ preventScroll: true });
      heading.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  });
}

if (!customElements.get('soe-consultation-summary')) {
  customElements.define('soe-consultation-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const saved = readSoeConsultationVisit(this.dataset.productId);
      if (!saved) return;
      this.state = saved;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' });
      this.labels = JSON.parse(this.querySelector('[data-soe-consultation-labels]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-soe-machine-variants]').textContent);
      this.machine = this.variants.find((v) => String(v.id) === this.dataset.selectedVariant);
      if (!this.machine) return;
      this.grinder = null;
      this.grinderFailed = false;
      const controller = this.controller = new AbortController();
      this.productScope = this.closest('product-info');
      this.productScope?.classList.add('soe-chooser-consultation');
      const revalidate = () => this.validateVisit();
      window.addEventListener('pageshow', revalidate, { signal: this.controller.signal });
      window.addEventListener('popstate', revalidate, { signal: this.controller.signal });
      document.addEventListener('visibilitychange', revalidate, { signal: this.controller.signal });
      this.querySelector('[data-soe-answer-summary]').textContent = saved.labels.join(' · ');
      this.hidden = false;
      this.refresh();
      if (this.controller !== controller) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.dataset.sectionId && data.variant) { this.machine = data.variant; this.refresh(); }
        });
      }
      if (saved.answers.grinder === 'separate' && /^[a-z0-9][a-z0-9-]*$/.test(saved.grinderHandle || '') && saved.grinderId && saved.grinderVariantId) {
        fetch((window.Shopify?.routes?.root || '/') + 'products/' + saved.grinderHandle + '.js', { credentials: 'same-origin', signal: this.controller.signal })
          .then((r) => { if (!r.ok) throw new Error('Unavailable'); return r.json(); })
          .then((product) => {
            if (this.controller !== controller || controller.signal.aborted) return;
            if (String(product.id) !== String(saved.grinderId)) throw new Error('Identity changed');
            const variant = product.variants.find((v) => String(v.id) === String(saved.grinderVariantId));
            if (!variant || !variant.available) throw new Error('Unavailable');
            this.grinder = variant;
            const link = this.querySelector('[data-soe-grinder-link]');
            link.textContent = product.title;
            link.href = (window.Shopify?.routes?.root || '/') + 'products/' + saved.grinderHandle + '?variant=' + variant.id;
            this.refresh();
          }).catch((error) => { if (this.controller === controller && error.name !== 'AbortError') { this.grinderFailed = true; this.refresh(); } });
      } else if (saved.answers.grinder === 'separate') { this.grinderFailed = true; this.refresh(); }
    }
    disconnectedCallback() { this.deactivateConsultation(); }
    deactivateConsultation() {
      clearTimeout(this.expiryTimer);
      this.controller?.abort();
      this.controller = null;
      this.unsubscribe?.();
      this.unsubscribe = null;
      this.productScope?.classList.remove('soe-chooser-consultation');
      this.hidden = true;
      this.state = null;
    }
    validateVisit() {
      const saved = readSoeConsultationVisit(this.dataset.productId);
      if (!this.state || !saved || saved.savedAt !== this.state.savedAt) {
        this.deactivateConsultation();
        return false;
      }
      clearTimeout(this.expiryTimer);
      this.expiryTimer = setTimeout(() => this.validateVisit(), Math.max(1, saved.savedAt + 7200001 - Date.now()));
      return true;
    }
    preserveSourceUrl(url) {
      if (this.hidden || !this.validateVisit()) return url;
      const current = new URL(window.location.href);
      const target = new URL(url, current);
      if (target.origin !== current.origin || target.pathname !== current.pathname) return url;
      target.searchParams.set('soe_setup', String(this.state.savedAt));
      return target.pathname + target.search + target.hash;
    }
    refresh() {
      if (!this.state || !this.validateVisit()) return;
      const m = this.machine;
      if (!m) return;
      const status = this.querySelector('[data-soe-context-status]');
      this.querySelector('[data-soe-machine-price]').textContent = this.money.format(m.price / 100);
      const needsGrinder = this.state.answers.grinder === 'separate';
      const complete = needsGrinder && !!this.grinder;
      this.querySelector('[data-soe-grinder-row]').hidden = !complete;
      this.querySelector('[data-soe-setup-row]').hidden = !complete;
      this.querySelector('[data-soe-purchase-note]').hidden = !needsGrinder;
      let amount = m.price;
      if (complete) {
        amount += this.grinder.price;
        this.querySelector('[data-soe-grinder-price]').textContent = this.money.format(this.grinder.price / 100);
        this.querySelector('[data-soe-setup-total]').textContent = this.money.format(amount / 100);
      }
      if (!m.available) status.textContent = this.labels.machineUnavailable;
      else if (needsGrinder && this.grinderFailed) status.textContent = this.labels.grinderUnavailable;
      else if (needsGrinder && !complete) status.textContent = this.labels.loading;
      else if (amount > this.state.maxBudget) status.textContent = this.labels.overBudget;
      else if (String(m.id) !== String(this.state.variantId)) status.textContent = this.labels.changed;
      else status.textContent = needsGrinder ? this.labels.pair : this.state.answers.grinder === 'owned' ? this.labels.owned : this.labels.machineOnly;
    }
  });
}
